import { createFileRoute } from '@tanstack/react-router'
import { EditClinicPage } from '_/features/pets/ui/pages/edit-clinic-page'

const EditClinicRoute = () => {
	const { clinicId } = Route.useParams()
	return <EditClinicPage clinicId={clinicId} />
}

export const Route = createFileRoute('/_authenticated/pets/clinics/$clinicId/edit')({
	staticData: { title: 'clinics_edit_title' },
	component: EditClinicRoute,
})
